import counterpart from "counterpart";

export function reportMetaData(permission, userId, checkboxEnabled, reportId) {
  return {
    id: 1,
    searchName: 'reports',
    pageId: '',
    name: ' ',
    headerName: 'Reports',
    displayType: 'gdTable',
    recordCountRequired: false,
    isCheckboxOnRowRequired: (permission !== undefined && permission !== null && permission.case.canUnAssignCase && checkboxEnabled) ? true : false,
    titleRequired: true,
    isPagable: true,
    detailViewTitle: 'Reports',
    returnToText: 'Return to Reports',
    canManageColumns: true,
    primaryColumnKey: 'caseStageId',
    dataColumns: [
    ],
    actions: reportId === '4' ? [
      {
        title: 'Remove',
        key: 'STAGE_CLOSE',
        style: {
          width: 150,
          paddingLeft: 0,
          fontSize: '13px',
          fontWeight: '500',
        },

      },
    ] :  [
        {
          title: 'View More Details',
          key: 'DETAIL_DRAWER',
          style: {
            width: 150,
            paddingLeft: 0,
          },

        },
      ]
    ,
    defaultSort: {
      bre_summary_rpt: [{
        key: 'count',
        order: 0,
      }],
      bre_detail_rpt: [{
        key: 'dueDate',
        order: 0,
      }],
      multiple_case_report: [{
        key: 'dueDate',
        order: 0,
      }],
      dispt_inv_rpt: [{
        key: 'dueDate',
        order: 0,
      }],
      dispute_product_rpt : [{
        key: 'count',
        order: 0,
      }],
      user_report : [{
        key: 'firstLoginDate',
        order: 0,
      }],
      merchant_gl_rpt : [{
        key: 'resolvedDate',
        order: 0,
      }]
    },
    columnStyle: {
      bre_summary_rpt: {
        width: 140,
      },
      bre_detail_rpt: {
        width: 90,
      },
      multiple_case_report: {
        width: 90,
      },
      dispt_inv_rpt: {
        width: 90,
      },
      dispute_product_rpt : {
        width: 140,
      },
      user_report : {
        width: 140,
      },
      merchant_gl_rpt : {

        width: 140,
      }
    },
    pageSize: 25,
    dateFormat: 'MM/DD/YYYY',
    isExportable: true,
    paginationRequired: true,
  };
}

export function getTranslations() {
  return {
    corpAndRegion:'Search Corp and Region',
    reasonCode:'Search Reason Code',
    dspstnCtgry:'Search Disposition Category',
    trnsctnCurrency:'Search Transaction Currency',
    sttlmntCrrncy:'Search Settlement Currency',
    applyFilterPane: 'Search',
    cancel: 'Cancel',
    clearFilterPane: 'Clear',
    less: 'Less',
    more: 'More',
    save: 'Save',
    select: 'Select',
    dates: {
      apply: 'Apply',
      cancel: 'Cancel',
      custom: 'Custom',
      fri: 'Fri',
      from: 'From',
      lastMonth: 'Last Month',
      lastSevenDays: 'Last 7 Days',
      lastThirtyDays: 'Last 30 Days',
      lastWeek: 'Last Week',
      lastYear: 'Select Date(s)',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      thu: 'Thu',
      to: 'To',
      tue: 'Tue',
      unselectedText: 'Select Date(s)',
      validDateError: 'Please enter a valid date.',
      wed: 'Wed',
      yesterday: 'Yesterday',
      jan:'January',
      feb:'February',
      mar:'March',
      apr:'April',
      may:'May',
      jun:'June',
      jul:'July',
      aug:'August',
      sep:'September',
      oct:'October',
      nov:'November',
      dec:'December',
    },
    actions: 'Actions',
    active: 'Active',
    addAll: 'Add All',
    apply: 'Apply',
    applyFilterPane: 'Apply',
    backLinkText: 'Back to Reports',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    clear: 'Reset',
    columns: 'Columns',
    createAFilterContent: 'To select a filter, please create a filter.',
    createAFilterTitle: 'Start by creating a filter',
    currency: 'Currency',
    export: 'Export',
    exporting: 'Exporting',
    exportTypesTitle: 'What do you want to export?',
    fileName: 'Name of file:',
    fileTypesTitle: 'Export As:',
    filterPaneTriggerText: 'Filter',
    filters: 'Filters',
    header: 'Export Data',
    hideAll: 'Hide All',
    inactive: 'Inactive',
    less: 'Less',
    more: 'More',
    next: 'Next',
    prev: 'Prev',
    page: 'Page',
    placeholder: 'Search by Filter Name...',
    preposition: 'of',
    removeAll: 'Remove All',
    save: 'Save',
    savedFilters: 'Saved Filters',
    searchCurrencies: 'Search Currencies',
    shareReport: 'Share Report',
    showAll: 'Show All',
    show25perPage: 'Show 25 per page',
    show50perPage: 'Show 50 per page',
    show75perPage: 'Show 75 per page',
    show100perPage: 'Show 100 per page',
    showingRecords: 'Showing records',
    summaryTitle: 'Summary',
    title: 'Saved Filters',
    saveFilterLabel: 'Filter Name',
    saveFilterTitle: 'Save Filter',
    availableColumns: 'Available Columns',
    availableFilterText: 'Available Filters',
    searchAvailableFilters: 'Search Report Filters',
    searchAvailableColumns: 'Search Available Columns',
    activeColumns: 'Active Columns',
    selected: 'Selected',
    searchActiveColumns: 'Search Active Columns',
    fileNameLabel: 'Name of File:',
    cardNum: 'Account Number (first 6 or last 4 digits)',
    helperText: '(first 6 or last 4 digits)',
    first6Placeholder: counterpart('globalTranslate.queues.firstSix'),
    last4Placeholder: counterpart('globalTranslate.queues.lastFour'),
    searchReasonCodePlaceholder: counterpart('globalTranslate.caseSearch.searchReasonCode'),
  };
}


export function addIconsToGDTableHeadersList(columns, pageListId) {
  if(pageListId === undefined){
    const idFromStorage = localStorage.getItem('pageListId');
            pageListId = idFromStorage;
  }
  const iconsColumns = columns.find((column) => column.displayType == 'ICON' && column.description == '');
  
  if (!iconsColumns && pageListId !== 'bre_summary_rpt' && pageListId !== 'user_report' && pageListId !== 'dispute_product_rpt' && pageListId !== 'merchant_gl_rpt' ) {
    columns.push({
      defaultIsVisible: true,
      description: '',
      isRequired: false,
      isSortable: false,
      isSummaryColumn: false,
      name: '',
      sortDirection: null,
      sortOrderPriority: 0,
      displayType: 'ICON',
      columnKey: 'OpenInNewTabIcon',
      displayOrder: 99,
      isSelected: true,
    });
  }
  if (!iconsColumns  && pageListId !== 'user_report' && pageListId !== 'merchant_gl_rpt' &&  pageListId !== 'dispute_product_rpt'){
    columns.push({
      defaultIsVisible: true,
      description: '',
      isRequired: false,
      isSortable: false,
      isSummaryColumn: false,
      name: '',
      sortDirection: null,
      sortOrderPriority: 0,
      displayType: 'ICON',
      columnKey: 'FolderIcon',
      displayOrder: 100,
      isSelected: true,
    });
  }
  return columns;
}


export function setDeafaultSearchFilterelements()
{
  let filterValues = [];
  filterValues = filterValues.concat({
    elementId: 'case_recd_date_from',
    elementValue: 'this_month',
    actualNameId: null, 
  });
  return filterValues;
}
export function getFormattedDimsStatus() {
  let filterValues = [];
  let statusValue = [{value : 'Active'},{value : 'Inactive'}];
    statusValue.forEach((filterValue) => {
          filterValues = filterValues.concat({
              value: filterValue.value,
              text: filterValue.value
      });
    });
  return filterValues;
}

export function getFormattedUserType(){
  let filterValues = [];
  let statusValue = [{value : 'External'},{value : 'Internal'}];
    statusValue.forEach((filterValue) => {
          filterValues = filterValues.concat({
              value: filterValue.value,
              text: filterValue.value
      });
    });
  return filterValues;
}

export function setDeafaultSearchFilterelementsforUserReport()
{
  let filterValues = [];
  filterValues = filterValues.concat({
    elementId: 'first_login_from',
    elementValue: 'this_month',
    actualNameId: null, 
  });
  return filterValues;
}
